/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Personal / Commercial License.
 * See LICENSE_PERSONAL / LICENSE_COMMERCIAL in the project root for license information on type of purchased license.
 */

import { Component, Input, OnInit } from '@angular/core';

import { NbMenuService, NbSidebarService } from '@nebular/theme';
import { UserData } from '../../../@core/interfaces/common/users';
import { AnalyticsService } from '../../../@core/utils';
import { LayoutService, TitleService } from '../../../@core/utils';
import { NbAuthJWTToken, NbAuthService } from '@nebular/auth';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {

  @Input() position = 'normal';

  user: any;
  name: string;
  userMenu = this.getMenuItems();

  defaultTitle: any = 'Available Projects';

  constructor(private sidebarService: NbSidebarService,
              private menuService: NbMenuService,
              private userService: UserData,
              private analyticsService: AnalyticsService,
              private layoutService: LayoutService,
              private authService: NbAuthService,
              public titleService: TitleService) {
    
    this.authService.onTokenChange()
      .subscribe((token: NbAuthJWTToken) => {

        if (token.isValid()) {
          this.user = token.getPayload(); // here we receive a payload from the token and assigne it to our `user` variable 
        }
      });
  
  }

  getMenuItems() {
    const userLink = this.user ?  `/pages/users/edit/${this.user.id}` : '';
    return [
      { title: 'My Profile', link: userLink, queryParams: { profile: true } },
      { title: 'Log out', link: '/auth/logout' },
    ];
  }

  ngOnInit() {
    this.userService.getCurrentUser()
      .subscribe((user: any) => {
        this.user = user;
        this.userMenu = this.getMenuItems();
        this.name = this.user.firstName + " " + this.user.lastName;
      });
    // this.toggleSidebar();
    // console.log("title:", this.titleService );
    this.titleService.currentTitle = this.defaultTitle;
    // console.log("title:", this.titleService.currentTitle);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(false, 'menu-sidebar');
    this.layoutService.changeLayoutSize();
    return false;
  }

  goToHome() {
    this.menuService.navigateHome();
  }

  startSearch() {
    this.analyticsService.trackEvent('startSearch');
  }
}
